// Competitive pricing structure inspired by market analysis
// To be applied across all service categories

export const trademarkPricingTiers = [
  {
    name: 'Essentials',
    price: '$35',
    wasPrice: '$90',
    priceNote: '+ Federal Filing Fee ($350)',
    description: 'Perfect for first-time trademark filers',
    popular: false,
    features: [
      'Simple form with relevant trademark queries',
      'Basic trademark search to check availability',
      'Complete report with application details',
      'Satisfaction guarantee by legal team',
      'Refusal Risk Meter for approval chances',
      'Electronic filing with USPTO',
      'Secure Online Account 24/7 access',
      'Calendar of important dates',
      'Status and document tracking'
    ]
  },
  {
    name: 'Standard',
    price: '$149',
    wasPrice: '$399',
    priceNote: '+ Federal Filing Fee ($350)',
    description: 'Ideal for growing businesses',
    popular: true,
    features: [
      'Everything in Essentials',
      'Trademark clearance by specialist',
      'Full research, filing and monitoring',
      'Trademark research and preparation',
      'USPTO filing assistance',
      'Application drafting and descriptions',
      'Responding to Office Actions',
      'Monitoring for conflicting applications',
      '24-hour fast processing',
      'Same-day serial number issued'
    ]
  },
  {
    name: 'Professional',
    price: '$199',
    wasPrice: '$599',
    priceNote: '+ Federal Filing Fee ($350)',
    description: 'Complete protection for established brands',
    popular: false,
    features: [
      'Everything in Standard',
      'Clearance by trademark attorney',
      'Comprehensive Search (Local, Federal & WWW)',
      'Likelihood of approval estimation',
      'Application assessment to avoid rejection',
      'Cease and Desist Letter template',
      'Transfer and Assignment Letter',
      '1 Year Trademark Monitoring (value $175)',
      'Notification of possible infringers'
    ]
  },
  {
    name: 'Premium',
    price: '$700',
    wasPrice: '$1,599',
    priceNote: '+ Federal Filing Fee ($350)',
    description: 'Maximum protection & premium service',
    popular: false,
    features: [
      'Everything in Professional',
      'Clearance by team of attorneys',
      'Highly increased approval chances',
      'Legal action assistance for infringement',
      '24-hour Expedited Processing',
      'Priority case handling',
      'Enforcement support',
      'Complete protection package',
      'White Glove Service'
    ]
  }
];

export const copyrightPricingTiers = [
  {
    name: 'Basic',
    price: '$99',
    priceNote: '+ USPTO Filing Fee ($65)',
    description: 'Essential copyright protection',
    popular: false,
    features: [
      'Copyright Registration Filing',
      'Basic Documentation Review',
      'Application Preparation',
      'Email Support',
      'Certificate Delivery',
      'Registration Monitoring',
      'Client Portal Access'
    ]
  },
  {
    name: 'Standard',
    price: '$199',
    priceNote: '+ USPTO Filing Fee ($65)',
    description: 'Complete copyright registration',
    popular: true,
    features: [
      'Everything in Basic',
      'Attorney Review',
      'Multiple Work Registration',
      'Priority Processing',
      'DMCA Takedown Template',
      'Infringement Alert (3 Months)',
      'Dedicated Support',
      'Expedited Filing Available'
    ]
  },
  {
    name: 'Professional',
    price: '$399',
    priceNote: '+ USPTO Filing Fee ($65)',
    description: 'Advanced protection package',
    popular: false,
    features: [
      'Everything in Standard',
      'Portfolio Management',
      'Enforcement Strategy',
      'Licensing Agreement Template',
      'Annual Monitoring',
      'Legal Consultation (1 Hour)',
      'Litigation Readiness Review',
      'Priority Support'
    ]
  },
  {
    name: 'Premium',
    price: '$799',
    priceNote: '+ USPTO Filing Fee ($65)',
    description: 'Comprehensive copyright solution',
    popular: false,
    features: [
      'Everything in Professional',
      'Unlimited Work Registration',
      'Full Portfolio Audit',
      'DMCA Compliance Setup',
      '24/7 Support Access',
      'Enforcement Action Support',
      'International Registration Guidance',
      'White Glove Service'
    ]
  }
];

export const patentPricingTiers = [
  {
    name: 'Basic Search',
    price: '$299',
    description: 'Essential patent search services',
    popular: false,
    features: [
      'Prior Art Search',
      'USPTO Database Review',
      'Basic Patentability Analysis',
      'Search Report Delivery',
      'Email Support',
      '3-5 Day Turnaround'
    ]
  },
  {
    name: 'Standard',
    price: '$599',
    description: 'Comprehensive patent services',
    popular: true,
    features: [
      'Everything in Basic Search',
      'Detailed Patentability Report',
      'Attorney Consultation',
      'International Database Search',
      'Risk Assessment',
      'Strategic Recommendations',
      'Priority Support'
    ]
  },
  {
    name: 'Professional Filing',
    price: '$1,499',
    priceNote: '+ USPTO Filing Fee ($varies)',
    description: 'Complete patent application',
    popular: false,
    features: [
      'Everything in Standard',
      'Provisional Patent Application',
      'Full Application Preparation',
      'Attorney Drafting',
      'Technical Drawings Review',
      'Claims Development',
      'Filing & Prosecution',
      'Office Action Responses'
    ]
  },
  {
    name: 'Premium Protection',
    price: '$3,999',
    priceNote: '+ USPTO Filing Fee ($varies)',
    description: 'Full-service patent protection',
    popular: false,
    features: [
      'Everything in Professional',
      'Non-Provisional Patent Application',
      'International PCT Filing',
      'Multiple Claim Sets',
      'Litigation Support',
      'Dedicated Patent Attorney',
      '24/7 Priority Access',
      'Multi-Year Strategy Planning'
    ]
  }
];

export const companyFormationPricingTiers = [
  {
    name: 'Starter',
    price: '$99',
    priceNote: '+ State Filing Fee',
    description: 'Basic business formation',
    popular: false,
    features: [
      'Business Name Availability Check',
      'Articles of Incorporation/Organization',
      'State Filing Assistance',
      'EIN Registration',
      'Operating Agreement Template',
      'Email Support',
      'Digital Document Delivery'
    ]
  },
  {
    name: 'Standard',
    price: '$249',
    priceNote: '+ State Filing Fee',
    description: 'Complete formation package',
    popular: true,
    features: [
      'Everything in Starter',
      'Registered Agent Service (1 Year)',
      'Business License Research',
      'Banking Resolution',
      'Stock Certificates (if applicable)',
      'Corporate Bylaws',
      'S-Corp Election Assistance',
      'Priority Support'
    ]
  },
  {
    name: 'Professional',
    price: '$499',
    priceNote: '+ State Filing Fee',
    description: 'Premium formation services',
    popular: false,
    features: [
      'Everything in Standard',
      'Attorney Consultation (1 Hour)',
      'Trademark Search & Filing',
      'Business Website Domain',
      'Tax Strategy Consultation',
      'Compliance Calendar',
      'Registered Agent (2 Years)',
      'Expedited Processing',
      'Dedicated Account Manager'
    ]
  },
  {
    name: 'Enterprise',
    price: '$999',
    priceNote: '+ State Filing Fee',
    description: 'Full-service business setup',
    popular: false,
    features: [
      'Everything in Professional',
      'Multi-State Registration',
      'Complete Compliance Setup',
      'Custom Legal Documents',
      'Intellectual Property Strategy',
      'Business Bank Account Setup',
      'Registered Agent (3 Years)',
      '24/7 Legal Support',
      'Annual Compliance Management',
      'White Glove Service'
    ]
  }
];
